module.exports = __webpack_public_path__ + "img/inconclusive-logo.2e316c74.svg";